//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { trace, context, TraceFlags, Span } from '@opentelemetry/api';

import { ClientBase } from './client-base';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export class IdentityClientBase extends ClientBase {
  getBaseUrl(_defaultUrl: string, _baseUrl: string) {
    return this.apiService.getServiceUrl('identity-api');
  }
}

@inject(String, HttpClient)
export class TokenClient extends IdentityClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("TokenClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5810", baseUrl);
    }

    async get(): Promise<void> {
        const span = this.tracer.startSpan("GET /Token", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async excelAccessToken(): Promise<string> {
        const span = this.tracer.startSpan("GET /Token/ExcelAccessToken", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Token/ExcelAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processExcelAccessToken(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processExcelAccessToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

@inject(String, HttpClient)
export class UsersClient extends IdentityClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("UsersClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5810", baseUrl);
    }

    async invite(policyId: number | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /Users/Invite", {
            attributes: {
                "policyId": policyId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Users/Invite?";
        if (policyId === null)
            throw new globalThis.Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInvite(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInvite(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function getTraceParent(span: Span) {
  return `00-${span.spanContext().traceId}-${span.spanContext().spanId}-0${Number(span.spanContext().traceFlags || TraceFlags.NONE).toString(16)}`;
}